import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import AccessControl from "components/common/AccessControl/accessControl";
import { Form, Formik } from "formik";
import { get } from "lodash";
import React from "react";
import Dropzone from "react-dropzone";

import { UploadDropzone } from "../../../components/icons";
import { downloadTemplatesYoutube } from "../../../config/index";
import YouTubeCsvTable from "./YouTubeCsvTable";

const ExportYoutbeCsv = ({ ...props }) => {
  const { importS3GlacierStreams, getDownloadVideosCSV, getYoutubeDownloadVideosData, setLoder, loder } = props;
  const antIcon = <LoadingOutlined style={{ fontSize: 30, color: "#000", align: "center" }} spin />;
  const onFileDrop = async (files) => {
    if (files && files.length > 0) {
      let data = new FormData();
      data.append("file", files[0]);
      data.append("filename", files[0].name);
      data.append("userId", localStorage.getItem("__uid"));
      // call api here
      const { value } = await getDownloadVideosCSV(data);
      value.status
        ? notification["success"]({ message: value?.message })
        : notification["error"]({ message: value.message });
    } else {
      notification["error"]({ message: "Please upload CSV file only." });
    }
    setLoder(false);
  };
  return (
    <div className="col-md-12">
      {" "}
      <Formik enableReinitialize>
        {({ errors, touched, setFieldValue, values }) => (
          <div className="modal-content">
            <Form>
              <div className="react-modal-header">
                <h5 className="react-modal-title">Upload CSV</h5>
                {/* <CloseModal /> */}
              </div>
              <div className="react-modal-body">
                <div className="form-container">
                  <AccessControl code="upload_youtube_csv" page="organization-profile">
                    <Dropzone
                      accept="text/*"
                      onDrop={(acceptedFiles) => {
                        setLoder(true);
                        onFileDrop(acceptedFiles);
                      }}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div className="dropzone-inner" {...getRootProps()}>
                            <input {...getInputProps()} type="file" accept=".csv" />
                            <div className="dropzone-icon">
                              <UploadDropzone />
                            </div>
                            <div className="dropzone-title">Upload a File</div>
                            <div className="dropzone-subtitle">Upload a CSV File</div>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  </AccessControl>
                </div>
                <div className="react-modal-footer justify-content-center">
                  <div className="react-foo-container">
                    <div className="right-btn-block">
                      <AccessControl code="download_youtube_csv" page="organization-profile">
                        <a
                          href={get(
                            downloadTemplatesYoutube,
                            "youTubeVideoCSV",
                            "https://d7xz21f54epr.cloudfront.net/3tBwdNb9s/csv/export_youtube_csv.csv",
                          )}
                          className="btn-text"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download Sample
                        </a>
                      </AccessControl>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        )}
      </Formik>
      <YouTubeCsvTable getYoutubeDownloadVideosData={getYoutubeDownloadVideosData} setLoder={setLoder} />
      {loder ? <Spin indicator={antIcon} className="loader__full" /> : null}
    </div>
  );
};

export default ExportYoutbeCsv;
